var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogofooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 57,
    viewBox: "0 0 112 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.081 12.2171C104.084 12.2818 104.084 12.3491 104.081 12.4139L103.431 13.4928C102.509 14.6889 100.957 15.0128 99.7607 15.8501C98.8761 16.4705 98.1959 17.1458 99.4243 17.9132C100.1 18.3368 100.605 18.3069 101.316 18.4415C104.318 19.0196 108.163 19.2787 109.616 15.9697C109.618 16.017 109.755 16.3908 109.813 16.463C109.808 16.5602 109.773 16.7645 109.763 16.8617L109.008 18.4315C108.492 18.9747 107.802 19.4532 107.082 19.6799C107.054 19.7173 107.458 20.2331 107.54 20.3178C107.645 20.4249 108.23 20.8809 108.23 20.9607C108.23 21.0878 107.779 21.1824 107.752 21.2223C107.438 21.7157 108.664 22.4308 108.99 22.6725C109.95 23.3802 110.964 24.0405 111.965 24.6884C112.018 24.7781 111.995 25.0397 111.985 25.1618L111.886 25.2615C111.881 25.2939 111.893 25.3287 111.886 25.3611C111.275 26.1834 110.513 26.1012 109.563 26.0514C107.077 25.9243 105.479 24.6709 103.411 24.3993C101.488 24.1476 98.769 26.2233 97.7125 27.7433C97.264 28.3911 97.0223 29.1187 96.666 29.8089C95.3079 28.0124 94.7298 26.019 93.915 23.9433C94.1368 23.7066 96.0281 21.7232 96.1751 21.6584C96.6909 21.4291 97.5804 21.5861 98.3479 21.1127C98.7217 20.8834 98.9858 20.4798 99.2973 20.1484C97.7872 20.3278 96.2174 20.6268 94.9317 19.6126C95.5596 19.0869 96.3819 18.9698 97.1643 18.9374C94.5828 16.022 98.8712 15.1997 100.787 14.3101C102.086 13.7071 103.262 12.9721 103.882 11.624C103.939 11.7137 104.076 12.1548 104.079 12.2171H104.081Z",
    fill: "url(#paint0_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6685 29.8065C97.0248 29.1163 97.2665 28.3887 97.715 27.7408C98.7691 26.2208 101.488 24.1452 103.414 24.3969C105.484 24.6685 107.079 25.9218 109.566 26.0489C110.513 26.0987 111.275 26.181 111.888 25.3587C111.751 26.0364 111.151 27.681 110.408 27.8878C110.127 27.9676 108.519 27.4692 107.989 27.4293C105.96 27.2798 103.648 27.4593 102.305 29.1661C102.123 29.3978 101.784 29.8464 101.856 30.103C102.584 29.1188 103.655 28.5631 104.871 28.4236C105.013 28.9468 104.876 29.5075 105.22 29.9635C105.372 30.1653 105.572 30.3298 105.766 30.4917C107.022 31.5258 108.268 32.5699 109.514 33.6114C108.467 34.1496 106.603 35.1065 105.427 35.0342C102.342 34.8473 98.485 32.2135 96.666 29.8065H96.6685Z",
    fill: "#AE8245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1544 48.1846C41.3413 49.7544 40.8479 50.9729 39.7291 52.0443C39.6095 52.1589 39.4002 52.1465 39.4376 52.3209L42.2956 56.9431H40.058C39.6643 56.5469 37.8104 53.1357 37.5837 53.1357H35.5853C35.5853 53.1357 35.4433 53.2678 35.4433 53.2777V56.9431H33.5396V51.3267H37.0131C37.5164 51.3267 38.7897 50.5891 38.8694 49.9936H33.5396V48.1846H41.1544Z",
    fill: "url(#paint1_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2891 55.5755C78.7276 58.2118 73.7416 56.779 73.4226 52.9891C73.0862 48.9997 77.858 46.7771 80.8905 49.234C82.839 50.8113 83.0508 53.7615 81.2866 55.5755H81.2891ZM77.2998 50.1111C74.534 50.5745 74.7383 55.0074 77.853 55.137C81.5732 55.2915 81.486 49.4084 77.2998 50.1111Z",
    fill: "url(#paint2_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3517 51.3249V53.2286H26.0218V55.0376H32.0669C32.0669 55.0376 32.2089 55.1697 32.2089 55.1796V56.7968C32.2089 56.7968 32.0768 56.9388 32.0669 56.9388H24.0234V51.3224H31.3517V51.3249Z",
    fill: "url(#paint3_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1501 52.7526V48.1827H51.0538V56.9387L50.5804 56.8889C48.2506 54.6862 45.8934 52.5009 43.6508 50.2085C43.601 50.0415 43.596 48.3945 43.6458 48.2425C43.7131 48.0406 43.9623 48.0581 44.1367 48.1029C45.3851 49.1993 46.5163 50.4277 47.7248 51.5615C48.0413 51.858 48.5546 52.3663 48.8686 52.608C48.9633 52.6803 48.9882 52.7924 49.1551 52.7501L49.1501 52.7526Z",
    fill: "url(#paint4_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1707 52.8472V48.1851H13.0744V56.9411L12.5461 56.8514L5.74609 50.3255V48.0879L6.27435 48.1776L11.1707 52.8472Z",
    fill: "url(#paint5_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3196 52.752V48.1821H91.2233V56.9382L90.6951 56.8485L83.895 50.3226V48.085L84.4233 48.1747C85.5097 49.1788 86.5338 50.2553 87.6053 51.2744C88.0014 51.6507 88.6393 52.3035 89.033 52.6075C89.1277 52.6798 89.1526 52.7919 89.3196 52.7496V52.752Z",
    fill: "url(#paint6_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.596 48.0879V55.0374H110.926V56.9411H103.598V48.0879H105.596Z",
    fill: "url(#paint7_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2867 56.9408H59.9544L55.9501 50.0884C55.8454 49.7097 56.5082 48.688 56.7375 48.3018C56.8695 48.0825 57.1985 48.1448 57.3853 48.2769L62.2867 56.9408Z",
    fill: "url(#paint8_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.122 56.9413L96.0901 50.0167C96.0452 49.9021 96.0901 49.8174 96.1274 49.7127C96.1698 49.5931 96.9173 48.3323 96.9821 48.2799C97.1565 48.1379 97.3833 48.1554 97.5851 48.2002L102.454 56.9413H100.122Z",
    fill: "url(#paint9_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0892 48.1846H70.0908V56.9406H72.0892V48.1846Z",
    fill: "url(#paint10_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.31826 48.1846H2.41455V56.9406H4.31826V48.1846Z",
    fill: "url(#paint11_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6874 48.1846H14.4072V50.0883H22.6874V48.1846Z",
    fill: "url(#paint12_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7577 48.1846H60.5723V50.0883H68.7577V48.1846Z",
    fill: "url(#paint13_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2089 48.1846V49.9462C32.2089 49.9462 32.0768 50.0883 32.0669 50.0883H24.0234V48.1846H32.2089Z",
    fill: "url(#paint14_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2907 56.9412H51.8164L55.1006 51.2325C55.5067 51.9327 56.0001 52.618 56.2916 53.3655L54.2907 56.9437V56.9412Z",
    fill: "url(#paint15_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0811 56.9415L95.2232 51.2303C95.3253 51.1606 96.4715 53.1241 96.4591 53.3633L94.4133 56.939H92.0811V56.9415Z",
    fill: "url(#paint16_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.618 51.3252H63.6196V56.9416H65.618V51.3252Z",
    fill: "url(#paint17_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.453 51.3252H17.5493V56.9416H19.453V51.3252Z",
    fill: "url(#paint18_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6293 56.9414H43.6309V52.1821C43.7978 52.1398 43.8202 52.2519 43.9174 52.3242C44.1242 52.4812 45.6293 53.8242 45.6293 53.9438V56.9414Z",
    fill: "url(#paint19_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7963 56.9409H83.8926V52.1816C84.1592 52.3311 85.7963 53.8138 85.7963 53.9433V56.9409Z",
    fill: "url(#paint20_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6498 56.9409H5.74609V52.1816C6.00025 52.3561 7.6498 53.8138 7.6498 53.9433V56.9409Z",
    fill: "url(#paint21_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.081 12.4139C103.992 14.37 102.103 15.0403 100.917 16.1192C99.7556 17.1757 99.945 17.7663 101.313 18.4415C100.6 18.3045 100.097 18.3344 99.4217 17.9133C98.1958 17.1458 98.8735 16.4705 99.7581 15.8501C100.954 15.0129 102.507 14.6889 103.428 13.4929L104.079 12.4139H104.081Z",
    fill: "#AE8245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9316 19.6104C95.0711 19.7025 95.2381 19.73 95.3901 19.7947C95.572 19.872 95.7564 19.9442 95.9457 20.0065C96.332 20.1336 96.7331 20.2134 97.1418 20.2283C97.9392 20.2582 98.734 20.1361 99.5239 20.0115C99.2249 20.3728 98.8885 20.7042 98.5197 20.9958C98.4774 21.0307 98.43 21.0655 98.3777 21.078C98.2905 21.0979 98.1908 21.0581 98.1061 21.0431C97.6127 20.9584 97.1044 21.0107 96.6085 20.916C96.2074 20.8388 95.8137 20.6993 95.4773 20.465C95.2306 20.2906 94.9017 19.9393 94.9316 19.6128V19.6104Z",
    fill: "#AE8245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.775 16.7964C109.69 17.524 109.406 18.2267 108.98 18.8222C108.773 19.1138 108.526 19.4028 108.245 19.6246C108.113 19.7292 107.968 19.814 107.841 19.9236C107.804 19.956 107.482 20.265 107.532 20.3148C107.315 20.1005 107.116 19.8713 106.937 19.6271C106.991 19.7018 107.751 19.2633 107.834 19.2135C108.285 18.9319 108.656 18.5482 108.967 18.1221C109.269 17.7084 109.598 17.2823 109.77 16.7939L109.775 16.7964Z",
    fill: "#AE8245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.813 16.4653C109.755 16.3905 109.618 16.0192 109.616 15.9719C109.613 15.9171 109.73 15.7651 109.813 15.4785C109.8 15.8049 109.835 16.1413 109.813 16.4653Z",
    fill: "#AE8245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.081 12.2171C104.079 12.1548 103.942 11.7138 103.884 11.624C103.949 11.482 103.944 11.4671 104.081 11.2303V12.2171Z",
    fill: "#AE8245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.888 25.2625L111.989 25.162C111.984 25.2349 111.891 25.255 111.888 25.2625Z",
    fill: "url(#paint22_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.007 21.5643C104.164 21.6216 104.308 21.7138 104.418 21.8558C104.517 21.9854 104.473 22.1175 104.306 22.125C103.999 22.1374 103.66 22.0602 103.371 21.968C103.239 21.9256 103.107 21.8733 102.985 21.806C102.885 21.7512 102.688 21.659 102.641 21.5543C102.875 21.4871 103.159 21.4771 103.401 21.4746C103.605 21.4746 103.817 21.4945 104.007 21.5643Z",
    fill: "#AE8245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2696 37.4164H38.4629V14.7861C40.0701 16.3211 41.6449 17.8984 43.2097 19.4781C43.5212 19.7946 43.8376 20.1036 44.1491 20.4175C44.8543 21.1277 45.5619 21.8378 46.2721 22.5455V37.4189L46.2696 37.4164Z",
    fill: "url(#paint23_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8195 13.4031C15.2074 13.3981 13.5902 13.4056 11.978 13.4031V37.4163C13.5902 37.4138 15.2074 37.4213 16.8195 37.4163C17.8063 37.4163 18.798 37.4188 19.7847 37.4163V13.4031C18.798 13.4031 17.8063 13.4056 16.8195 13.4031Z",
    fill: "url(#paint24_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6058 31.388C93.1847 30.8224 92.8458 30.1895 92.4496 29.6064C90.4312 29.6064 88.4104 29.6114 86.3921 29.6064C82.0464 29.5964 77.6933 29.6438 73.3477 29.6064C72.8543 29.6014 72.3585 29.6089 71.8651 29.6064V0.0614932H70.0361L55.1653 14.9847C55.1653 14.8651 55.0955 14.7704 55.0207 14.6857C51.2582 10.4123 46.5089 6.58245 42.6665 2.33399C41.8318 1.66868 41.2138 0.744238 40.3666 0.0839191C40.262 0.041559 40.1499 0.073952 40.0452 0.0639849C38.443 -0.0780458 36.4596 0.0689685 34.8075 0.0639849C33.1629 0.0590014 31.5109 0.0639849 29.8663 0.0639849L0 0.0590014V9.44798C5.88057 9.44798 11.7661 9.44549 17.6467 9.44798C21.2224 9.44798 24.8056 9.44798 28.3812 9.44798H38.5601L55.2126 26.0481L63.9587 17.4515L64.0584 37.4131L71.3717 37.5128C71.4714 37.5128 71.5686 37.5128 71.6682 37.5128C71.9324 37.5128 72.1965 37.5128 72.4581 37.5128C72.7546 37.5128 73.0512 37.5128 73.3477 37.5128C77.7282 37.5178 82.1112 37.5128 86.4918 37.5128C88.8614 37.5128 91.2361 37.5128 93.6083 37.5128C96.0452 37.5128 98.4896 37.5551 100.922 37.4629C98.0112 36.0775 95.5269 33.962 93.6083 31.3855L93.6058 31.388Z",
    fill: "url(#paint25_linear_15_335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.823 0.156778C104.938 0.171728 101.046 0.134352 97.1613 0.156778C93.5632 0.156778 90.0946 0.485691 87.3263 0.904308C87.0696 0.94916 86.9376 0.981553 86.8902 0.994012C86.3171 1.12358 86.1801 1.16594 85.7066 1.36279C76.0535 5.40693 71.1024 16.0343 75.2686 25.4557H84.7224L83.0479 22.782C80.7356 17.8857 82.7689 11.9329 87.4609 9.18196C87.4559 9.10721 87.4633 9.25671 87.4609 9.18196C90.7126 7.58225 93.6006 7.94106 97.261 7.961C97.3656 7.961 97.4703 7.961 97.5749 7.961C97.6372 7.961 97.6995 7.961 97.7618 7.961C101.447 7.94604 105.137 7.97345 108.823 7.961V0.156778Z",
    fill: "url(#paint26_linear_15_335)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_335",
    x1: 93.9175,
    y1: 20.7165,
    x2: 112,
    y2: 20.7165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15_335",
    x1: 33.5396,
    y1: 52.5626,
    x2: 42.2981,
    y2: 52.5626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15_335",
    x1: 73.4077,
    y1: 52.563,
    x2: 82.4927,
    y2: 52.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15_335",
    x1: 24.0209,
    y1: 54.1331,
    x2: 32.2089,
    y2: 54.1331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15_335",
    x1: 43.6084,
    y1: 52.5084,
    x2: 51.0538,
    y2: 52.5084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15_335",
    x1: 5.74609,
    y1: 52.5158,
    x2: 13.0744,
    y2: 52.5158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15_335",
    x1: 83.8925,
    y1: 52.5153,
    x2: 91.2233,
    y2: 52.5153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_15_335",
    x1: 103.598,
    y1: 52.5158,
    x2: 110.926,
    y2: 52.5158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_15_335",
    x1: 55.9376,
    y1: 52.5478,
    x2: 62.2867,
    y2: 52.5478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_15_335",
    x1: 96.0726,
    y1: 52.5558,
    x2: 102.454,
    y2: 52.5558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_15_335",
    x1: 70.0908,
    y1: 52.5626,
    x2: 72.0892,
    y2: 52.5626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_15_335",
    x1: 2.41455,
    y1: 52.5626,
    x2: 4.31826,
    y2: 52.5626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_15_335",
    x1: 14.4072,
    y1: 49.1364,
    x2: 22.6899,
    y2: 49.1364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_15_335",
    x1: 60.5723,
    y1: 49.1364,
    x2: 68.7577,
    y2: 49.1364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_15_335",
    x1: 24.0209,
    y1: 49.1364,
    x2: 32.2089,
    y2: 49.1364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_15_335",
    x1: 51.8164,
    y1: 54.0856,
    x2: 56.2916,
    y2: 54.0856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_15_335",
    x1: 92.0811,
    y1: 54.0859,
    x2: 96.4566,
    y2: 54.0859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_15_335",
    x1: 63.6196,
    y1: 54.1334,
    x2: 65.618,
    y2: 54.1334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_15_335",
    x1: 17.5493,
    y1: 54.1334,
    x2: 19.453,
    y2: 54.1334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_15_335",
    x1: 43.6309,
    y1: 54.5568,
    x2: 45.6293,
    y2: 54.5568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_15_335",
    x1: 83.8926,
    y1: 54.5613,
    x2: 85.7963,
    y2: 54.5613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_15_335",
    x1: 5.74609,
    y1: 54.5613,
    x2: 7.6498,
    y2: 54.5613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_15_335",
    x1: 111.888,
    y1: 25.2123,
    x2: 111.989,
    y2: 25.2123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_15_335",
    x1: 38.4604,
    y1: 26.1013,
    x2: 46.2696,
    y2: 26.1013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_15_335",
    x1: 11.9755,
    y1: 25.4085,
    x2: 19.7847,
    y2: 25.4085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_15_335",
    x1: 0,
    y1: 18.7622,
    x2: 100.919,
    y2: 18.7622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_15_335",
    x1: 73.786,
    y1: 12.8025,
    x2: 108.823,
    y2: 12.8025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9B265"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 56.9419,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogofooter);
export default __webpack_public_path__ + "static/media/logofooter.b0c8dff5a588e0dc951fd8f052b0d5d6.svg";
export { ForwardRef as ReactComponent };